
export default {
    shiftTypeLookup : state => (shiftTypeId) => state.getAllShiftType.find((a) => a.shiftTypeId === shiftTypeId),

    scheduleTypeLookup : state => (scheduleTypeId) => state.getAllScheduleType.find(a => a.scheduleTypeId === scheduleTypeId),

    segmentTypeLookup : state => (segmentTypeId) => state.getAllSegmentType.find(a => a.segmentTypeId === segmentTypeId),

    leaveTypeLookup : state => (leaveTypeId) => state.getAllLeaveTypes.find(a => a.leaveTypeId === leaveTypeId),

    createPayrollTypeIdById : state => (createPayrollTypeId) => state.getAllCreatePayrollTypeLookup.find(a => a.createPayrollTypeId === createPayrollTypeId),

    claimsCategoryName: state => (claimsCategoryId) => state.claimsCategory.find(a => a.claimsCategoryId === claimsCategoryId),

    claimsSubCategoryName: state => (claimsSubCategoryId) => state.claimsSubCategory.find(a => a.claimsSubCategoryId === claimsSubCategoryId),

    claimsSubCategoryByCategory: state => (claimsCategoryId) => state.claimsSubCategory.filter(a => a.claimsCategoryId === claimsCategoryId),

    loanTypeLookup: state => (loanTypeId) => state.getAllLoanType.find(a => a.loanTypeId === loanTypeId),

    loanNameLookup: state => (loanNameId) => state.getAllLoanName.find(a => a.loanNameId === loanNameId),

    loanNameLookupByLoanType: state => (loanTypeId) => state.getAllLoanName.filter(a => a.loanTypeId === loanTypeId),

    loanStatusLookup: state => (loanStatusId) => state.getAllLoanStatus.find(a => a.value === loanStatusId),

    loanNameByLoanType: state => (loanTypeId) => state.getAllLoanName.find(a => a.loanTypeId === loanTypeId),

    loanCategoryLookup: state => (loanCategoryId) => state.loanCategory.find(a => a.loanCategoryId === loanCategoryId),

    loanSubCategoryLookup: state => (loanSubCategoryId) => state.loanSubCategory.find(a => a.loanSubCategoryId === loanSubCategoryId),

    loanSubCategoryByCategory: state => (loanCategoryId) => state.loanSubCategory.filter(a => a.loanCategoryId === loanCategoryId),

    termsTypeLookup: state => (termsTypeId) => state.getAllTermsType.find(t => t.value === termsTypeId),

    termsTypeLookupByPaymentMode: state => (paymentModeId) => state.getAllTermsType.filter(t => {
        switch(paymentModeId){
            case 1: //Daily
                return t.value === 1
                break;
            case 2: //Monthly
                return t.value === 4
                break;
            case 3: //Semi-Monthly
                return t.value >= 3 && t.value <= 4
                break;
            case 4: //weekly
                return t.value === 2
                break
        }

    }),

    overtimeType: state => (overtimeTypeId) => state.overtimeTypes.find(a => a.overtimeTypeId === overtimeTypeId),

    residentialType: state => (resTypeId) => state.residentialType.find(a => a.value === resTypeId),

    empStatus: state => (value) => state.employeeStatus.find(a => a.value === value),

    employStatus: state => (value) => state.employmentStatus.find(a => a.value === value),

    gender: state => (value) => state.gender.find(a => a.value === value),


    department: state => (departmentId) => state.getAllDepartment.find(a =>  a.departmentId === departmentId),

    branch: state => (branchId) => state.getAllBranch.find(a => a.branchId === branchId),

    position: state => (positionId) => state.getAllPosition.find(a => a.positionId === positionId),

    division: state => (divisionId) => state.getAllDivision.find(a => a.divisionId === divisionId),

    section: state => (sectionId) => state.getAllSection.find(a => a.sectionId === sectionId),

    employeeCategory: state => (employeecategoryId) => state.getAllEmployeeCategory.find(a => a.employeeCategoryId === employeecategoryId),

    civilStatus: state => (civilstatusId) => state.getAllCivilStatus.find(a => a.civilStatusId === civilstatusId),

    nationality: state => (nationalityId) => state.getAllNationality.find(a => a.nationalityId === nationalityId),

    religion: state => (religionId) => state.getAllReligion.find(a => a.religionId === religionId),

    relationshipLookup: state => (relationshipId) => state.getAllRelationshipLookup.find(a => a.relationshipId === relationshipId),

    accreditationType: state => (id) => state.getAllAccreditationType.find(a => a.accreditationTypeId === id),

    rankLookup: state => (rankId) => state.getAllRankLookup.find(a => a.rankId === rankId),

    associationLookup: state => (associationId) => state.getAllAssociationLookup.find(a => a.associationId === associationId),

    bankLookup: state => (bankId) => state.getAllBankLookup.find(a => a.bankId === bankId),

    periodLookup: state => (periodId) => state.getAllPeriodLookup.find(a => a.periodId === periodId),

    periodLookupForCreatePayroll: state => (paymentModeId) => state.getAllPeriodLookup.filter(a => {
        switch(a.paymentModeId) {
            case 2:
                return a.paymentModeId === paymentModeId
                break;
            case 3:
                return a.paymentModeId === paymentModeId && a.periodId !== 5
                break;
            case 4:
                return a.paymentModeId === paymentModeId && a.periodId !== 11
                break;
        }
    }),
    periodLookupByPaymentMode: state => (paymentModeId) => state.getAllPeriodLookup.filter(a => a.paymentModeId === paymentModeId),

    accountType: state => (value) => state.accountType.find(a => a.value === value),

    benefitTypeLookup: state => (benefitTypeId) => state.getAllBenefitTypeLookup.find(a => a.benefitTypeId === benefitTypeId),

    lineOfBusinessLookup: state => (lineOfBusinessId) => state.getAllLineOfBusinessLookup.find(a => a.lineOfBusinessId === lineOfBusinessId),

    degreeLookup: state => (degreeId) => state.getAllDegreeLookup.find(a => a.degreeId === degreeId),

    areaOfStudyLookup: state => (areaOfStudyId) => state.getAllAreaOfStudyLookup.find(a => a.areaOfStudyId === areaOfStudyId),

    institutionLookup: state => (institutionId) => state.getAllInstitutionLookup.find(a => a.institutionId === institutionId),

    awardLookup: state => (awardId) => state.getAllAwardLookup.find(a => a.awardId === awardId),

    appraisalRatingLookup: state => (appraisalRatingId) => state.getAllAppraisalRatingLookup.find(a => a.appraisalRatingId === appraisalRatingId),

    appraisalTypeLookup: state => (appraisalTypeId) => state.getAllAppraisalTypeLookup.find(a => a.appraisalTypeId === appraisalTypeId),

    marketSegmentLookup: state => (marketSegmentId) => state.getAllMarketSegmentLookup.find(a => a.marketSegmentId === marketSegmentId),

    taxReferenceLookup: state => (taxReferenceId) => state.getAllTaxReferenceLookup.find(a => a.taxReferenceId === taxReferenceId),

    salaryBasedOnLookup: state => (salaryBasedOnId) => state.getAllSalaryBasedOnLookup.find(a => a.salaryBasedOnId === salaryBasedOnId),

    paymentModeActive: state => (value) => state.getAllPaymentModeLookup.filter(a => a.isUsed === value),

    paymentModeLookup: state => (paymentModeId) => state.getAllPaymentModeLookup.find(a => a.paymentModeId === paymentModeId),

    violationActionLookup: state => (violationActionId) => state.getAllViolationActionLookup.find(a => a.violationActionId === violationActionId),

    violationLookup: state => (violationId) => state.getAllViolationLookup.find(a => a.violationId === violationId),

    medicalProcedureLookup: state => (medicalProcedureId) => state.getAllMedicalProcedureLookup.find(a => a.medicalProcedureId === medicalProcedureId),

    countryLookup: state => (countryName) => state.getAllCountryLookup.find(a => a.countryName === countryName),

    monthLookup: state => (value) => state.monthName.find(a => a.value === value),

    earningsTypeLookup: state => (id) => state.getAllEarningsType.find(a => a.earningsTypeId === id),

    earningsCategoryLookup: state => (id) => state.getAllEarningsCategory.find(a => a.earningsCategoryId === id),

    deductionsTypeLookup: state => (id) => state.getAllDeductionsType.find(a => a.deductionsTypeId === id),

    deductionsCategoryLookup: state => (id) => state.getAllDeductionsCategory.find(a => a.deductionsCategoryId === id),

    moduleLookup: state => (id) => state.moduleLookup.find(a => a.value === id),

    priorityLookup: state => (id) => state.priorityLookup.find(a => a.value === id),

    addToLookup: state => (id) => state.addToLookup.find(a => a.value === id),

    getDayName: state => (dayNo) => state.daysName.find(a => a.value === dayNo),

    getScheduleNumberName: state => scheduleNumberId =>  state.getAllScheduleNumber.find(a => a.scheduleNumberId === scheduleNumberId)


}
